import * as React from "react";
function SvgIcTwitter(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.44 12.67L5.033 5.5H9.2l3.544 4.7 4.385-4.7h1.224l-5.063 5.427L19 18.5h-4.166l-3.848-5.104L6.224 18.5H5l5.44-5.83zM8.75 6.398H6.836l8.451 11.211h1.914L8.75 6.4z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgIcTwitter;
